var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84375 9.02344C4.77752 9.02344 3.91016 9.8908 3.91016 10.957V16.1992C3.91016 17.2654 4.77752 18.1328 5.84375 18.1328C6.90998 18.1328 7.77734 17.2654 7.77734 16.1992V10.957C7.77734 9.8908 6.90998 9.02344 5.84375 9.02344Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62109 10.957C2.62109 10.7711 2.64563 10.5915 2.67601 10.4142C1.89922 10.6652 1.33203 11.3868 1.33203 12.2461V14.9102C1.33203 15.7695 1.89922 16.491 2.67601 16.7421C2.64563 16.5648 2.62109 16.3851 2.62109 16.1992V10.957Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 9.02344C15.09 9.02344 14.2227 9.8908 14.2227 10.957V16.1992C14.2227 17.2654 15.09 18.1328 16.1562 18.1328C16.35 18.1328 16.5336 18.0955 16.7102 18.0422C16.4703 18.8375 15.7397 19.4219 14.8672 19.4219H12.8149C12.5479 18.6733 11.8392 18.1328 11 18.1328C9.93377 18.1328 9.06641 19.0002 9.06641 20.0664C9.06641 21.1326 9.93377 22 11 22C11.8392 22 12.5479 21.4595 12.8149 20.7109H14.8672C16.6441 20.7109 18.0898 19.2652 18.0898 17.4883V16.1992V10.957C18.0898 9.8908 17.2225 9.02344 16.1562 9.02344Z",
    fill: "#4B9BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3242 10.4142C19.3546 10.5915 19.3791 10.7711 19.3791 10.957V16.1992C19.3791 16.3851 19.3546 16.5648 19.3242 16.7421C20.101 16.491 20.6682 15.7695 20.6682 14.9102V12.2461C20.6682 11.3868 20.101 10.6652 19.3242 10.4142Z",
    fill: "#4B9BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C5.66878 0 1.33203 4.33675 1.33203 9.66797V9.68443C1.71604 9.3937 2.16034 9.18096 2.65061 9.0857C2.95187 4.73735 6.57654 1.28906 11 1.28906C15.4235 1.28906 19.0481 4.73735 19.3494 9.08566C19.8396 9.18092 20.2839 9.3937 20.668 9.68438V9.66797C20.668 4.33675 16.3312 0 11 0Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineConsult);
export default __webpack_public_path__ + "static/media/online_consult.7aec22f89e80fcbd06c8651d93f41dac.svg";
export { ForwardRef as ReactComponent };